/**
 * Labstep
 *
 * @module components/ProtocolCollection/Action/View
 * @desc Action linking to protocol collection
 */

import EntityActionView from 'labstep-web/components/Entity/Action/View';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type React from 'react';
import type { IProtocolCollectionActionViewProps } from './types';

export const ProtocolCollectionActionView: React.FC<
  IProtocolCollectionActionViewProps
> = ({ protocolCollection, actionComponentProps }) => (
  <EntityActionView
    entityName={ProtocolCollection.entityName}
    params={{ id: protocolCollection.id }}
    actionComponentProps={actionComponentProps}
  />
);
